/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async constructChart() {
    let data = { source: "Web" };
    let response = await apiCall("account-chart/construct", data);
    return response;
  },

  async listAccountCategories() {
    let data = { source: "Web" };
    let response = await apiCall("account-chart/category/list", data);
    return response;
  },

  async listAccountsForCategory(categoryId) {
    let data = { category_id: categoryId };
    let response = await apiCall("account-chart/category/account/list", data);
    return response;
  },

  async createAccount(data) {
    let response = await apiCall("account-chart/create", data);
    return response;
  },

  async importAccounts(accountsFile) {
    let data = { accounts_file: accountsFile };
    let response = await apiCall("account-chart/import", data);
    return response;
  },

  async updateAccount(accountNumber, accountName, description, accountId) {
    let data = {
      account_name: accountName,
      account_number: accountNumber,
      account_id: accountId,
      description: description,
    };
    let response = await apiCall("account-chart/update", data);
    return response;
  },

  async deleteAccount(accountId) {
    let data = { account_id: accountId };
    let response = await apiCall("account-chart/delete", data);
    return response;
  },

  async fetchChart() {
    let response = await apiCall("accountchart/account/chart_of_accounts", []);
    return response;
  },

  async fetchParentAccounts(category_ids) {
    const data = {
      account_category_ids: category_ids
    }
    let response = await apiCall("accountchart/account/list_parent_accounts", data);
    return response;
  },

  async fetchAllAccounts() {
    let response = await apiCall("accountchart/account/list_all", []);
    return response;
  },

  async changeAccountHierarchy(accountId, newParentId) {
    const data = {
      account_id: accountId,
      new_parent_id: newParentId
    };
    let response = await apiCall("accountchart/account/change_hierarchy", data);
    return response;
  },
  async fetchBankAccounts() {
    let response = await apiCall("platform/generalaccounts/bank_accounts", []);
    return response;
  },
  async linkBank(data) {
    let response = await apiCall("platform/generalaccounts/link_bank", data);
    return response;
  },
  async unlinkBank(data) {
    let response = await apiCall("platform/generalaccounts/unlink_bank", data);
    return response;
  },

  

  
};
